import request from '@/utils/request';


export async function get(payload){
  return request(`/iwms-wms/wms/purchaseConfig/getByDc?dcUuid=${payload}`)
}

export async function saveOrModify(payload){
  return request(`/iwms-wms/wms/purchaseConfig/saveOrModify`,{
    method: 'POST',
    body: payload
  })
}
